import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Recommended(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.074 19.62a1 1 0 110 2h-12a1 1 0 110-2h12zm-6-17.62a2.498 2.498 0 011.5 4.498l2.038 4.466 2.29-1.787a2.502 2.502 0 012.246-3.597c1.378 0 2.5 1.12 2.5 2.5a2.504 2.504 0 01-1.55 2.312l-1.954 7.319a1 1 0 01-.966.742H5.968c-.452 0-.85-.305-.966-.742l-1.956-7.32A2.504 2.504 0 011.5 8.08c0-1.38 1.122-2.5 2.5-2.5a2.502 2.502 0 012.245 3.599l2.288 1.785 2.039-4.466A2.497 2.497 0 019.573 4.5c0-1.38 1.121-2.5 2.5-2.5zm-.002 6.027l-2.246 4.919a1.003 1.003 0 01-.91.585.997.997 0 01-.614-.212l-3.035-2.367 1.47 5.5h10.672l1.467-5.5-3.032 2.367a.997.997 0 01-1.525-.373l-2.247-4.92zM4 7.58c-.275 0-.5.225-.5.5s.225.5.5.5a.5.5 0 000-1zm16.148 0a.5.5 0 000 1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM12.073 4a.5.5 0 000 1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoRecommended = React.memo(Recommended);
export default MemoRecommended;